;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('inputTags', inputTags)

  /* @ngInject */
  function inputTags () {
    return {
      restrict: 'EA',
      scope: {
        label: '@',
        modelPropertyName: '@',
        model: '=',
        value: '<',
        change: '&',
        placeholder: '@',
        disabled: '=',
        options: '<',
        description: '@',
        link: '@',
        pricing: '<',
        pricingTooltip: '<',
        pricingTooltipPosition: '<',
        pricingData: '<'
      },
      templateUrl: '/core/directives/input-tags/input-tags-directive.html?$$REVISION$$',
      controller: 'InputTagsController'
    }
  }
})()
